import { STATE_EVENTS, PLAYBACK_EVENTS } from '../constants';
export var NATIVE_EVENTS = [
    'loadstart',
    'loadedmetadata',
    'canplay',
    'play',
    'playing',
    'pause',
    'ended',
    'waiting',
    'seeking',
    'seeked',
];
var StateEvents = /** @class */ (function () {
    function StateEvents(eventEmitter, audioElement) {
        var _this = this;
        this._currentState = STATE_EVENTS.INIT;
        this._processEventFromAudio = function (event) {
            switch (event.type) {
                case 'loadstart': {
                    _this.setState(STATE_EVENTS.LOAD_STARTED);
                    break;
                }
                case 'loadedmetadata': {
                    _this.setState(STATE_EVENTS.METADATA_LOADED);
                    break;
                }
                case 'canplay': {
                    if (_this._currentState === STATE_EVENTS.METADATA_LOADED) {
                        _this.setState(STATE_EVENTS.READY_TO_PLAY);
                    }
                    break;
                }
                case 'play': {
                    _this.setState(STATE_EVENTS.PLAY_REQUESTED);
                    break;
                }
                case 'playing': {
                    _this.setState(STATE_EVENTS.PLAYING);
                    break;
                }
                case 'waiting': {
                    _this.setState(STATE_EVENTS.WAITING);
                    break;
                }
                case 'pause': {
                    _this.setState(STATE_EVENTS.PAUSED);
                    break;
                }
                case 'ended': {
                    _this.setState(STATE_EVENTS.ENDED);
                    break;
                }
                case 'seeking': {
                    _this.setState(STATE_EVENTS.SEEK_IN_PROGRESS);
                    break;
                }
                case 'seeked': {
                    _this.setState(_this._audioElement.paused
                        ? STATE_EVENTS.PAUSED
                        : STATE_EVENTS.PLAYING);
                    break;
                }
                default:
            }
        };
        this._eventEmitter = eventEmitter;
        this._audioElement = audioElement;
        this._bindEvents();
    }
    StateEvents.prototype._bindEvents = function () {
        var _this = this;
        NATIVE_EVENTS.forEach(function (event) {
            return _this._audioElement.addEventListener(event, _this._processEventFromAudio);
        });
    };
    StateEvents.prototype._unbindEvents = function () {
        var _this = this;
        NATIVE_EVENTS.forEach(function (event) {
            return _this._audioElement.removeEventListener(event, _this._processEventFromAudio);
        });
    };
    StateEvents.prototype.setState = function (state) {
        if (state === this._currentState) {
            return;
        }
        this._eventEmitter.emit(PLAYBACK_EVENTS.STATE_CHANGED, {
            prevState: this._currentState,
            nextState: state,
        });
        this._eventEmitter.emit(state);
        this._currentState = state;
    };
    StateEvents.prototype.getState = function () {
        return this._currentState;
    };
    StateEvents.prototype.destroy = function () {
        this._unbindEvents();
        delete this._audioElement;
        delete this._eventEmitter;
    };
    return StateEvents;
}());
export default StateEvents;
//# sourceMappingURL=state-events.js.map